<div class="account-banned-wrapper">
  <div class="account-banned-hint">
    Your account was banned. If you think this was a mistake, please send us an
    email with your username.
  </div>
</div>
